/* GENERATED FILE */
import { forwardRef } from "react";
import variants from "../defs/mic";
import IconBase from "../lib/icon-base";
import type { Icon } from "../lib/types";

const I: Icon = forwardRef((props, ref) => (
	<IconBase ref={ref} {...props} variants={variants} />
));

I.displayName = "Mic";
export { I as Mic };
